/*
 * action types
 */
export const PAGE_MODE_SLIDE = 'PAGE_MODE_SLIDE'
export const MODE_SLIDE_ACTIVE = 'MODE_SLIDE_ACTIVE'

/*
 * action creators
 */
export function setPageModeSlide(payload) {
  return {
    payload,
    type: PAGE_MODE_SLIDE,
  }
}

/*
 * action creators
 */
export function setIsModeSlideActive(payload) {
  return {
    payload,
    type: MODE_SLIDE_ACTIVE,
  }
}
